import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

export function PairingCodeButton({ onPaired, testId = "generate-pairing-code-button" }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState(null);
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/v1/devices/pair-code");
      setCode(data);
      setOpen(true);
      onPaired?.();
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button variant="outline" size="sm" data-testid={testId} onClick={generate} disabled={loading}>
        <KeyRound className="mr-2 h-4 w-4" />
        {loading ? "Generating…" : "Generate pairing code"}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="pairing-code-dialog">
          <DialogHeader>
            <DialogTitle className="font-display">Pairing code</DialogTitle>
            <DialogDescription>
              Enter this code in the MIA app on your device. It expires in 10 minutes and can be used once.
            </DialogDescription>
          </DialogHeader>
          <div className="rounded-xl border border-border bg-secondary/60 py-6 text-center">
            <span className="font-mono text-3xl font-medium tracking-[0.3em]" data-testid="pairing-code-value">
              {code?.pairing_code}
            </span>
          </div>
          <p className="text-xs text-muted-foreground">
            The MIA watchOS app is currently in development. Pairing codes are live for early device testing.
          </p>
        </DialogContent>
      </Dialog>
    </>
  );
}
